/** Flushed by the Canvas render loop, including immersive XR frames. */
export function createRenderPlaybackClock(now = () => performance.now()) {
    let serial = 0;
    const frames = new Map();
    const delays = new Map();
    const clock = {
        now,
        requestFrame(callback) { frames.set(++serial, callback); return serial; },
        cancelFrame(handle) { frames.delete(handle); },
        delay(callback, duration) { delays.set(++serial, { callback, due: now() + duration }); return serial; },
        cancelDelay(handle) { delays.delete(handle); },
    };
    return {
        clock,
        tick() {
            const timestamp = now();
            const pending = [...frames];
            const due = [...delays].filter(([, entry]) => entry.due <= timestamp);
            for (const [id, callback] of pending) {
                if (!frames.delete(id))
                    continue;
                callback(timestamp);
            }
            for (const [id, entry] of due) {
                if (!delays.delete(id))
                    continue;
                entry.callback();
            }
        },
    };
}
